import * as React from "react";
const SvgBadge = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m12.43 8.402 1.983 3.425c.14.232.14.522 0 .754a.732.732 0 0 1-.637.366h-2.1l-1.069 1.8a.637.637 0 0 1-.124.154.731.731 0 0 1-.512.205h-.103a.731.731 0 0 1-.534-.352L7.92 12.303l-1.412 2.43a.732.732 0 0 1-.534.358h-.103a.731.731 0 0 1-.505-.205.73.73 0 0 1-.131-.16l-1.069-1.801h-2.1a.732.732 0 0 1-.637-1.098l1.983-3.425a5.123 5.123 0 1 1 9.016 0m-7.216 3.454.651 1.09 1.12-1.917a5.124 5.124 0 0 1-2.613-1.346l-1.046 1.815h1.266a.732.732 0 0 1 .622.358M7.92 9.632a3.66 3.66 0 1 1 0-7.319 3.66 3.66 0 0 1 0 7.319m2.708 2.224a.732.732 0 0 1 .622-.358l1.266-.022-1.046-1.815a5.167 5.167 0 0 1-2.606 1.346l1.113 1.94z"
      clipRule="evenodd"
    />
    <mask
      id="Badge_svg__a"
      width={14}
      height={16}
      x={1}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fillRule="evenodd"
        d="m12.43 8.402 1.983 3.425c.14.232.14.522 0 .754a.732.732 0 0 1-.637.366h-2.1l-1.069 1.8a.637.637 0 0 1-.124.154.731.731 0 0 1-.512.205h-.103a.731.731 0 0 1-.534-.352L7.92 12.303l-1.412 2.43a.732.732 0 0 1-.534.358h-.103a.731.731 0 0 1-.505-.205.73.73 0 0 1-.131-.16l-1.069-1.801h-2.1a.732.732 0 0 1-.637-1.098l1.983-3.425a5.123 5.123 0 1 1 9.016 0m-7.216 3.454.651 1.09 1.12-1.917a5.124 5.124 0 0 1-2.613-1.346l-1.046 1.815h1.266a.732.732 0 0 1 .622.358M7.92 9.632a3.66 3.66 0 1 1 0-7.319 3.66 3.66 0 0 1 0 7.319m2.708 2.224a.732.732 0 0 1 .622-.358l1.266-.022-1.046-1.815a5.167 5.167 0 0 1-2.606 1.346l1.113 1.94z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#Badge_svg__a)">
      <path d="M.699.666h15.238v15.238H.699z" />
    </g>
  </svg>
);
export default SvgBadge;
